/**
 * Laser beam.
 * Automatically set length on intersection.
 */
AFRAME.registerComponent('cursor-laser', {
  dependencies: ['geometry'],

  schema: {
    enabled: {default: true}
  },

  init: function () {
    const el = this.el;
    this.weaponEl = this.el.closest('.weapon');

    // Calculate size to position beam at tip of controller.
    const geometry = this.el.getAttribute('geometry');
    el.object3D.position.z = -1 * geometry.height / 2;
    this.originalSize = geometry.height;
    this.currentLength = geometry.height;
  },

  update: function () {
    this.el.object3D.visible = this.data.enabled;
  },

  tick: function () {
    const el = this.el;

    if (!this.data.enabled) { return; }

    const cursor = this.weaponEl.components.cursor;
    if (!cursor) { return; }

    // Toggle beam.
    const intersectedEl = cursor.intersectedEl;

    if (!intersectedEl) {
      // Retract the beam if not intersecting.
      el.object3D.position.z = -24.98;
      el.object3D.scale.x = 0.75;
      el.getObject3D('mesh').scale.y = 50;
      this.currentLength = 1;
      return;
    }

    // Set appropriate length of beam on intersection.
    const intersection = this.weaponEl.components.raycaster.intersections[0];
    if (!intersection) { return; }
    el.object3D.scale.x = 1;
    el.object3D.position.z = (-intersection.distance / 2);
    el.getObject3D('mesh').scale.y = this.currentLength = intersection.distance;
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['cursor-laser',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
